import React from 'react';
import BookmarkButton from '@alltrails/shared/components/BookmarkButton';
import { getTrackProfilePhotoUrl, getFormattedTrackUrls } from 'utils/track_helpers';
import { wrapEventHandler } from 'utils/handlers';
import * as styles from '../HoverCard/styles/styles.module.scss';
import AddRemoveButton from '../../shared/AddRemoveButton/AddRemoveButton';
import CardBottomButtons from '../CardBottomButtons';
import CardImage from '../CardImage';
import CardLink from '../CardLink';
import MapTypeBadge from '../../shared/badges/MapTypeBadge';
import TrackCardContent from '../TrackCardContent';

export default function TrackHoverCard({
  allowItemAdd,
  bottomButtonsConfig,
  containerWidth,
  context,
  handleCardClick,
  handleFavoriteClick,
  handleItemAddClick,
  handleMouseEnter,
  handleMouseLeave,
  isFavorite,
  itemAddLabel,
  track
}) {
  const renderAddButton = allowItemAdd && handleItemAddClick;
  const { localizedUrl } = getFormattedTrackUrls(track, context);
  const contentWidth = containerWidth * 0.65;
  return (
    <div
      className={styles.container}
      style={{ width: containerWidth }}
      onMouseEnter={wrapEventHandler(handleMouseEnter)}
      onMouseLeave={wrapEventHandler(handleMouseLeave)}
    >
      {/* statically positioned */}
      <CardLink target="_blank" title={track.name} url={localizedUrl} handleClick={handleCardClick} />
      <CardImage className={styles.image} url={getTrackProfilePhotoUrl(track, 'medium')} title={track.name} lazyload={false} />
      <div style={{ width: contentWidth }}>
        <TrackCardContent
          bottomButtonsConfig={bottomButtonsConfig}
          className={styles.content}
          context={context}
          namePaddingRight={24}
          track={track}
          userImageClassNameOverride={styles.userImage}
        />
        <CardBottomButtons className={styles.bottomButtons} config={bottomButtonsConfig} />
      </div>
      {/* absolute positioned */}
      <MapTypeBadge className={`${styles.badge} ${styles.fullWidth}`} mapType={track.type} />
      {renderAddButton && <AddRemoveButton addLabel={itemAddLabel} className={styles.add} handleClick={handleItemAddClick} isInCollection={false} />}
      <BookmarkButton className={styles.bookmarkButton} onWhiteBackground onClick={wrapEventHandler(handleFavoriteClick)} isSelected={isFavorite} />
    </div>
  );
}

TrackHoverCard.defaultProps = {
  containerWidth: 344
};
